module.exports = __webpack_public_path__ + "img/side_qq.7fbd7c2c.png";